import { render, staticRenderFns } from "./businessUnitsForm.vue?vue&type=template&id=6b19da64&"
import script from "./businessUnitsForm.vue?vue&type=script&lang=js&"
export * from "./businessUnitsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports